import Home from './components/home.vue';
import Contact from './components/contact.vue';
import Features from './components/features.vue';
import Order from './components/order.vue';
import Sms from './components/a.vue';

export const routes = [
  { path: '/', component: Home },
  { path: '/contact', component: Contact},
  { path: '/order', component: Order},
  { path: '/features', component: Features},
  { path: '/sms', component: Sms},
]
